<template>
  <section>
    <div class="content_bg" :style="borderStyle">
      <!-- <div ></div> -->
      <div class="content">
        <Caption label="스크린샷"></Caption>
        <div class="content_core">
          <ul>
            <li v-for="m of record.screenshot">
              <img width="270" :src="m" />
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>
</template>
  
<script>
import Caption from "./Caption.vue";
import CaptionGreen from "./CaptionGreen.vue";
import CaptionWhite from "./CaptionWhite.vue";
import client from "../client/client";

export default {
  props: ["record", "color"],
  components: {
    Caption,
    CaptionGreen,
    CaptionWhite,
  },
  mounted() {},
  data() {
    return {};
  },
  computed: {
    borderStyle() {
      return {
        backgroundColor: this.color + '0F',
      };
    },
  },
};
</script>
  
<style scoped>
.content_bg {
  height: 950px;
  display: flex;
  justify-content: center;
  background-color: #ffffff;
  position: relative;
}

.content {
  width: 100vw;
  height: 100%;
  max-width: 1140px;
  display: inline-block;
  padding-top: 50px;
}

.content_core {
  margin-top: 100px;
  text-align: left;
  width: 1124px;
  max-width: 1124px;
  display: inline-block;
  overflow: hidden;
  overflow-x: scroll;
  white-space: nowrap;
}

ul {
  width: fit-content;
  height: fit-content;
  list-style-type: none;
  padding-inline-start: 0px;
  display: flex;
}

li {
  margin-right: 20px;
  display: inline-block;
}

@media screen and (max-width: 1440px) {
  .content_bg {
    height: fit-content;
    background-color: #ffffff;
  }

  .content {
    width: 100vw;
    height: fit-content;
    display: inline-block;
    position: relative;
    padding-top: 50px;
    padding-bottom: 50px;
    text-align: center;
  }

  .content_core {
    display: inline-block;
    height: fit-content;
    margin-left: 0px;
    margin-top: 0px;
    text-align: center;
    width: fit-content;
    position: relative;
  }

  ul {
    width: fit-content;
    height: fit-content;
    list-style-type: none;
    overflow: hidden;
    overflow-y: scroll;
    padding-inline-start: 0px;
    text-align: center;
    display: inline-block;
  }

  li {
    margin-right: 0px;
    margin-top: 30px;
    display: block;
  }
}
</style>
  